import { Config } from 'wagmi';
import { getAccount, watchAccount } from '@wagmi/core';
import { Address } from 'viem';

type WaitOpts = { timeoutMs?: number; signal?: AbortSignal };

export function waitAddress(wagmiConfig: Config, { timeoutMs = 120000, signal }: WaitOpts = {}) {
  const account = getAccount(wagmiConfig);
  if (account.status === 'connected') return Promise.resolve(account.address);

  return new Promise<Address>((resolve, reject) => {
    let settled = false;

    const unwatch = watchAccount(wagmiConfig, {
      onChange(next) {
        if (!settled && next.status === 'connected') {
          settled = true;
          // eslint-disable-next-line no-use-before-define
          cleanup();
          resolve(next.address);
        }
      },
    });

    const onAbort = () => {
      if (!settled) {
        settled = true;
        // eslint-disable-next-line no-use-before-define
        cleanup();
        reject(new DOMException('aborted', 'AbortError'));
      }
    };

    const t = setTimeout(() => {
      if (!settled) {
        settled = true;
        // eslint-disable-next-line no-use-before-define
        cleanup();
        reject(new Error('Connection timeout'));
      }
    }, timeoutMs);

    function cleanup() {
      clearTimeout(t);
      unwatch?.();
      signal?.removeEventListener('abort', onAbort);
    }

    signal?.addEventListener('abort', onAbort);
  });
}
